var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5C14 6.90625 12.875 8 11.5 8C10.0938 8 9 6.90625 9 5.5C9 4.125 10.0938 3 11.5 3C12.875 3 14 4.125 14 5.5ZM18 0C19.0938 0 20 0.90625 20 2V9C20 10.125 19.0938 11 18 11H5C3.875 11 3 10.125 3 9V2C3 0.90625 3.875 0 5 0H18ZM18 1.5H5C4.71875 1.5 4.5 1.75 4.5 2V9C4.5 9.28125 4.71875 9.5 5 9.5H18C18.25 9.5 18.5 9.28125 18.5 9V2C18.5 1.75 18.25 1.5 18 1.5ZM1.5 10.25C1.5 11.5 2.5 12.5 3.75 12.5H16.25C16.6562 12.5 17 12.8438 17 13.25C17 13.6875 16.6562 14 16.25 14H3.75C1.65625 14 0 12.3438 0 10.25V2.75C0 2.34375 0.3125 2 0.75 2C1.15625 2 1.5 2.34375 1.5 2.75V10.25Z",
    fill: "#61A60E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.abafb2099d8ea1c3248741b4cccc928d.svg";
export { ForwardRef as ReactComponent };